import React from 'react'
import { Grid, Typography, useTheme } from '@mui/material'

// ==============================|| SETTLEMENT EMPTY STATE DESCRIPTION ||============================== //

const SettlementEmptyStateDescription = () => {
  const theme = useTheme()

  return (
    <>
      Settlement tracking requires external portfolios to be configured. Follow these steps to get
      started:
      <br />
      <Grid
        container
        direction="column"
        gap={1}
        alignItems="center"
        justifyContent="center"
        sx={{
          p: 2,
          border: `1px solid ${theme.palette.secondary.dark}`,
          backgroundColor: theme.palette.secondary.main,
          borderRadius: '4px',
          mt: 2,
        }}
      >
        <Grid item xs={12} container direction="column" alignItems="center" justifyContent="center">
          <Typography
            variant="subtitle2"
            sx={{
              width: '16px',
              height: '16px',
              borderRadius: '100%',
              textAlign: 'center',
              color: theme.palette.secondary.light,
              backgroundColor: theme.palette.primary.dark,
              marginBottom: 1,
              lineHeight: '16px',
            }}
          >
            1
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Navigate to Portfolios
          </Typography>
          <Typography variant="body1">
            Navigate to Portfolios page from the main navigation menu
          </Typography>
        </Grid>
        <Grid item xs={12} container direction="column" alignItems="center" justifyContent="center">
          <Typography
            variant="subtitle2"
            sx={{
              width: '16px',
              height: '16px',
              borderRadius: '100%',
              textAlign: 'center',
              color: theme.palette.secondary.light,
              backgroundColor: theme.palette.primary.dark,
              marginBottom: 1,
              lineHeight: '16px',
            }}
          >
            2
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Create External Portfolio
          </Typography>
          <Typography variant="body1">
            Add a new portfolio and mark it as "External". External portfolios represent
            counterparties.
          </Typography>
        </Grid>
        <Grid item xs={12} container direction="column" alignItems="center" justifyContent="center">
          <Typography
            variant="subtitle2"
            sx={{
              display: 'block',
              width: '16px',
              height: '16px',
              borderRadius: '100%',
              textAlign: 'center',
              color: theme.palette.secondary.light,
              backgroundColor: theme.palette.primary.dark,
              marginBottom: 1,
              lineHeight: '16px',
            }}
          >
            3
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Return to Settlement
          </Typography>
          <Typography variant="body1">
            Once external portfolios are added, return here to configure the counterparty policy and
            the system will begin calculating settlements automatically.
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default SettlementEmptyStateDescription
